import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./pages/home/Home";
import Movies from "./pages/movies/Movies";
import WebSeries from "./pages/Webseries/Webseries";
import Sports from "./pages/Sports/Sports";
import News from "./pages/News/News";
import CategoryNews from "./pages/News/CategoryNews";
import LatestBuzz from "./pages/LatestBuzz";
import Wishlist from "./pages/Wishlist";

import Header from "./components/Header";
import Sidebar from "./components/Sidebar/Sidebar";
import BottomNav from "./components/BottomNav";
import Booking from "./pages/Booking/Booking";
import ShortsPage from "./pages/shorts/ShortsPage";

function App() {
  return (
    <BrowserRouter>
      <div className="app-layout">
        <Sidebar />

        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/movies" element={<Movies />} />
            <Route path="/webseries" element={<WebSeries />} />
            <Route path="/sports" element={<Sports />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/:category" element={<CategoryNews />} />
            <Route path="/buzz" element={<LatestBuzz/>} />
            <Route path="/wishlist" element={<Wishlist />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/booking/:movieId" element={<Booking />} />
            <Route path="/shorts" element={<ShortsPage />} />
          </Routes>
        </main>
      </div>

      <BottomNav />
    </BrowserRouter>
  );
}


export default App;
